export enum ECategory {
  SELECT_CATEGORY = 'select_category',
  HOME = 'home',
  GRAPHIC_INPUTS = 'graphic_inputs',
  GRAPHIC_NURSERY_MORTALITY = 'graphic_nursery_mortality',
  GRAPHIC_HEALTH_ANALYSIS = 'graphic_health_analysis',
  GRAPHIC_WATER_QUALITY_BY_PARAMETERS = 'graphic_water_quality_by_parameters',
  GRAPHIC_BIOMETRICS_BY_PARAMETERS = 'graphic_biometrics_by_parameters',
  GRAPHIC_BIOMETRICS_BY_NURSERIES = 'graphic_biometrics_by_nurseries',
  GRAPHIC_WATER_ANALYSIS_BY_NURSERIES = 'graphic_water_analysis_by_nurseries',
  REPORT_CONSUMPTION = 'report_consumption',
  REPORT_PRODUCTION = 'report_production',
  REPORT_FINANCIAL = 'report_financial',
  PRODUCTION_FARM_PHYSICAL_NURSERY = 'production_farm_physical_nursery',
  PRODUCTION_FARM_PHYSICAL_INPUTS = 'production_farm_physical_inputs',
  PRODUCTION_CULTIVATION_NURSERIES_BY_CYCLES = 'production_cultivation_nurseries_by_cycles',
  PRODUCTION_CULTIVATION_SETTLEMENT = 'production_cultivation_settlement',
  PRODUCTION_CULTIVATION_TRANSFERS = 'production_cultivation_transfers',
  PRODUCTION_CULTIVATION_CONSUMPTION = 'production_cultivation_consumption',
  PRODUCTION_CULTIVATION_METRICS_ANALYSIS_WATER = 'production_cultivation_metrics_analysis_water',
  PRODUCTION_CULTIVATION_METRICS_BIOMETRICS = 'production_cultivation_metrics_biometrics',
  PRODUCTION_CULTIVATION_METRICS_ANALISYS_HEALTH = 'production_cultivation_metrics_analysis_health',
  PRODUCTION_CULTIVATION_MORTALITY = 'production_cultivation_mortality',
  PRODUCTION_CULTIVATION_FISHING = 'production_cultivation_fishing',
  PRODUCTION_MANAGEMENT_STOCK = 'production_management_stock',
  PRODUCTION_MANAGEMENT_SHIPMENT = 'production_management_shipment',
  PRODUCTION_SETTINGS_PARAMETERS = 'production_settings_parameters',
  PRODUCTION_SETTINGS_MEASURES = 'production_settings_measures',
  PRODUCTION_SETTINGS_FORMS = 'production_settings_forms',
  SHOPPING_SUPPLIERS = 'shopping_suppliers',
  SHOPPING_LIST_PURCHASES = 'shopping_list_purchases',
  FINANCIAL_COST_CENTER = 'financial_cost_center',
  FINANCIAL_PAYMENTS = 'financial_payments',
  FINANCIAL_RECEIPTS = 'financial_receipts',
  FINANCIAL_ACCOUNT_CONTROL_MY_ACCOUNTS = 'financial_account_control_my_accounts',
  FINANCIAL_ACCOUNT_CONTROL_TRANSITIONS = 'financial_account_control_transitions',
  COMERCIAL_SHOPPING_SUPPLIERS = 'comercial_shopping_suppliers',
  COMERCIAL_SHOPPING_LIST_PURCHASES = 'comercial_shopping_list_purchases',
  COMERCIAL_SALES = 'comercial_sales',
  EMPLOYEES_USERS = 'employees_users',
}
export const ELabel: Record<ECategory, string> = {
  [ECategory.SELECT_CATEGORY]: 'Selecione uma categoria',
  [ECategory.HOME]: 'Inicio',
  [ECategory.GRAPHIC_INPUTS]: 'Gráficos de insumos',
  [ECategory.GRAPHIC_NURSERY_MORTALITY]: 'Gráficos - Mortalidade de Viveiros ',
  [ECategory.GRAPHIC_HEALTH_ANALYSIS]: 'Gráficos - Análise de Saúde ',
  [ECategory.GRAPHIC_WATER_QUALITY_BY_PARAMETERS]:
    'Gráficos - Qualidade da Água por Parâmetros ',
  [ECategory.GRAPHIC_BIOMETRICS_BY_PARAMETERS]:
    'Gráficos - Biometria por Parâmetros ',
  [ECategory.GRAPHIC_BIOMETRICS_BY_NURSERIES]:
    'Gráficos - Biometria por Viveiros ',
  [ECategory.GRAPHIC_WATER_ANALYSIS_BY_NURSERIES]:
    'Gráficos - Análise de Água por Viveiros ',
  [ECategory.REPORT_CONSUMPTION]: 'Relatório de Consumo',
  [ECategory.REPORT_PRODUCTION]: 'Relatório de Produção',
  [ECategory.REPORT_FINANCIAL]: 'Relatório Financeiro',
  [ECategory.PRODUCTION_FARM_PHYSICAL_NURSERY]:
    'Produção - Fazenda - Viveiro Físico',
  [ECategory.PRODUCTION_FARM_PHYSICAL_INPUTS]: 'Produção - Fazenda - Insumos',
  [ECategory.PRODUCTION_CULTIVATION_NURSERIES_BY_CYCLES]:
    'Produção - Viveiros por Ciclos',
  [ECategory.PRODUCTION_CULTIVATION_SETTLEMENT]:
    'Produção - Cultivo - Povoamentos',
  [ECategory.PRODUCTION_CULTIVATION_TRANSFERS]:
    'Produção - Cultivo - Transferências',
  [ECategory.PRODUCTION_CULTIVATION_CONSUMPTION]:
    'Produção - Cultivo - Consumo',
  [ECategory.PRODUCTION_CULTIVATION_METRICS_ANALYSIS_WATER]:
    'Produção - Cultivo - Medições - Análise de Água',
  [ECategory.PRODUCTION_CULTIVATION_METRICS_BIOMETRICS]:
    'Produção - Cultivo - Medições - Biometria',
  [ECategory.PRODUCTION_CULTIVATION_METRICS_ANALISYS_HEALTH]:
    'Produção - Cultivo - Medições - Análise de Saúde',
  [ECategory.PRODUCTION_CULTIVATION_MORTALITY]:
    'Produção - Cultivo - Mortalidade',
  [ECategory.PRODUCTION_CULTIVATION_FISHING]: 'Produção - Cultivo - Despesca',
  [ECategory.PRODUCTION_MANAGEMENT_STOCK]: 'Produção - Gerenciamento - Estoque',
  [ECategory.PRODUCTION_MANAGEMENT_SHIPMENT]:
    'Produção - Gerenciamento - Remessas',
  [ECategory.PRODUCTION_SETTINGS_PARAMETERS]:
    'Produção - Configurações - Parâmetros',
  [ECategory.PRODUCTION_SETTINGS_MEASURES]:
    'Produção - Configurações - Medidas',
  [ECategory.PRODUCTION_SETTINGS_FORMS]:
    'Produção - Configurações - Formulários',
  [ECategory.SHOPPING_SUPPLIERS]: 'Compras - Fornecedores',
  [ECategory.SHOPPING_LIST_PURCHASES]: 'Compras - Listar Compras',
  [ECategory.FINANCIAL_COST_CENTER]: 'Financeiro - Centro de Custo',
  [ECategory.FINANCIAL_PAYMENTS]: 'Financeiro - Pagamentos',
  [ECategory.FINANCIAL_RECEIPTS]: 'Financeiro - Recebimentos',
  [ECategory.FINANCIAL_ACCOUNT_CONTROL_MY_ACCOUNTS]:
    'Financeiro - Controle de Conta - Minhas Contas',
  [ECategory.FINANCIAL_ACCOUNT_CONTROL_TRANSITIONS]:
    'Financeiro - Controle de Conta - Transações',
  [ECategory.COMERCIAL_SHOPPING_SUPPLIERS]:
    'Comercial - Compras - Fornecedores',
  [ECategory.COMERCIAL_SHOPPING_LIST_PURCHASES]:
    'Comercial - Compras - Lista de Compras',
  [ECategory.COMERCIAL_SALES]: 'Comercial - Vendas',
  [ECategory.EMPLOYEES_USERS]: 'Funcionários - Usuários',
};

export const ELabelReverse: Record<string, ECategory> = Object.fromEntries(
  Object.entries(ELabel).map(([key, value]) => [value, key as ECategory])
);
